import { useSuspenseQuery } from '@tanstack/react-query'

import { contractQueries, ZContractActionType } from '@/entities/contract'
import { Dashboard, formatThumbnailsForDisplay } from '@/widgets/dashboard'

export const Todo = () => {
  const {
    data: contractCount,
    refetch: refetchContractCount,
    isFetching: isFetchingContractCount,
  } = useSuspenseQuery({
    ...contractQueries.hostContractActionsCount(),
    meta: {
      useCustomHandling: true,
    },
  })

  const {
    currentTime: contractCountTime,
    waitingApprovalCount,
    waitingCheckFinishCount,
    waitingApprovalRoomPics,
    waitingCheckFinishRoomPics,
  } = contractCount

  const waitingApprovalThumbnails = formatThumbnailsForDisplay(
    waitingApprovalRoomPics,
    waitingApprovalCount,
  )
  const waitingCheckFinishThumbnails = formatThumbnailsForDisplay(
    waitingCheckFinishRoomPics,
    waitingCheckFinishCount,
  )

  return (
    <Dashboard.Card>
      <Dashboard.Header>
        <Dashboard.Title>할 일</Dashboard.Title>
        <Dashboard.Refresh
          time={contractCountTime}
          onRefresh={refetchContractCount}
          isRefreshing={isFetchingContractCount}
        />
      </Dashboard.Header>
      <Dashboard.Content columns={2} className="gap-3">
        <Dashboard.ContractItem
          title="승인대기"
          href={`/host/contract?actionType=${ZContractActionType.Enum.WAITING_APPROVAL}`}
          count={waitingApprovalCount}
          thumbnails={waitingApprovalThumbnails}
        />
        <Dashboard.ContractItem
          title="퇴실점검"
          href={`/host/contract?actionType=${ZContractActionType.Enum.WAITING_CHECK_FINISH}`}
          count={waitingCheckFinishCount}
          thumbnails={waitingCheckFinishThumbnails}
        />
      </Dashboard.Content>
    </Dashboard.Card>
  )
}
